import React from 'react';
import DropDownFilterInputOption from '../DropDownFilterInputOption';
import { Option } from 'framework/form';
import { getPrimitiveOptionValue } from 'framework/form/input/dropdownHelper';

interface DropdownListLayoutProps {
  selectedValues?: Option[];
  onChangeCallback: any;
}

const MultipleDropdownListLayout = ({ selectedValues, onChangeCallback }: DropdownListLayoutProps) => {
  const handleClickSelectedItem = (optionValue: string | number) => {
    const newFilterValues = selectedValues?.filter(({ value }) => getPrimitiveOptionValue(value) !== optionValue);

    onChangeCallback({ target: { value: newFilterValues } });
  };

  return (
    <>
      {selectedValues?.map(({ value: optionValue, label: optionLabel }) => (
        <DropDownFilterInputOption
          value={getPrimitiveOptionValue(optionValue)}
          isMulti
          isSelected
          component="div"
          onClick={() => handleClickSelectedItem(getPrimitiveOptionValue(optionValue))}
          key={getPrimitiveOptionValue(optionValue)}
        >
          {optionLabel}
        </DropDownFilterInputOption>
      ))}
    </>
  );
};

export default MultipleDropdownListLayout;
